import { RDA_DASHBOARD_CONSTANTS as actionTypes } from '@store/constants';

const initialState = {
  overall: {
    isLoading: false,
    isError: false,
    error: null,
    data: [],
    totalPages: 1
  },
  truelayer: {
    isLoading: false,
    isError: false,
    error: null,
    data: [],
    totalPages: 1
  },
  clearbank: {
    accountDetails: {},
    isLoading: false,
    isError: false,
    error: null,
    data: [],
    totalPages: 1
  },
  ybl: {
    isLoading: false,
    isError: false,
    error: null,
    data: [],
    totalPages: 1
  },
  holidays: {
    holidayList: [],
    coutryToCodeMap: {},
    isLoading: false
  },
  yblDowntimeList: {
    isLoading: false,
    isError: false,
    error: null,
    data: [],
    totalPages: 1,
    pageNumber: 0
  },
  // Add routingConfigs and routingConfigMeta state
  routingConfigs: {
    isLoading: false,
    isError: false,
    error: null,
    data: []
  },
  routingConfigMeta: {
    isLoading: false,
    isError: false,
    error: null,
    data: {}
  },
  fulfillmentBalances: {
    isLoading: false,
    isError: false,
    error: null,
    data: []
  },
  metaData: {
    isLoading: false,
    isError: false,
    error: null,
    data: null
  },
};

const rdaDashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GETTING_OVERALL_TXNS:
      return {
        ...state,
        overall: {
          ...state.overall,
          isLoading: true,
          isError: false,
          error: null
        }
      };
    case actionTypes.GET_OVERALL_TXNS_SUCCESS:
      return {
        ...state,
        overall: {
          isLoading: false,
          isError: false,
          error: null,
          data: payload?.data,
          totalPages: payload?.totalPages
        }
      };
    case actionTypes.GET_OVERALL_TXNS_FAIL:
      return {
        ...state,
        overall: {
          ...state.overall,
          isLoading: false,
          isError: true,
          error: payload?.message
        }
      };

    case actionTypes.GETTING_YBL_PARTNER_TXNS:
      return {
        ...state,
        ybl: {
          ...state.ybl,
          isLoading: true,
          isError: false,
          error: null
        }
      };
    case actionTypes.GET_YBL_PARTNER_TXNS_SUCCESS:
      return {
        ...state,
        ybl: {
          isLoading: false,
          isError: false,
          error: null,
          data: payload?.data,
          totalPages: payload?.totalPages
        }
      };
    case actionTypes.GET_YBL_PARTNER_TXNS_FAIL:
      return {
        ...state,
        ybl: {
          ...state.ybl,
          isLoading: false,
          isError: true,
          error: payload?.message
        }
      };

    case actionTypes.GETTING_TL_TXNS:
      return {
        ...state,
        truelayer: {
          ...state.truelayer,
          isLoading: true,
          isError: false,
          error: null
        }
      };
    case actionTypes.GET_TL_TXNS_SUCCESS:
      return {
        ...state,
        truelayer: {
          isLoading: false,
          isError: false,
          error: null,
          data: payload?.data,
          totalPages: payload?.totalPages
        }
      };
    case actionTypes.GET_TL_TXNS_FAIL:
      return {
        ...state,
        truelayer: {
          ...state.truelayer,
          isLoading: false,
          isError: true,
          error: payload?.message
        }
      };

    case actionTypes.GETTING_CB_TXNS:
      return {
        ...state,
        clearbank: {
          ...state.clearbank,
          isLoading: true,
          isError: false,
          error: null
        }
      };
    case actionTypes.GET_CB_TXNS_SUCCESS:
      return {
        ...state,
        clearbank: {
          isLoading: false,
          isError: false,
          error: null,
          data: payload?.data,
          totalPages: payload?.totalPages
        }
      };
    case actionTypes.GET_CB_TXNS_FAIL:
      return {
        ...state,
        clearbank: {
          ...state.clearbank,
          isLoading: false,
          isError: true,
          error: payload?.message
        }
      };
    case actionTypes.GETTING_HOLIDAY_DATA:
      return {
        ...state,
        holidays: {
          isLoading: true
        }
      };
    case actionTypes.GETTING_HOLIDAY_DATA_SUCCESS:
      return {
        ...state,
        holidays: {
          ...state.holidays,
          holidayList: payload,
          isLoading: false
        }
      };
    case actionTypes.GETTING_CLEAR_BANK_ACCOUNT_DETAILS:
      return {
        ...state,
        clearbank: { ...state.clearbank, isLoading: true }
      };
    case actionTypes.GETTING_CLEAR_BANK_ACCOUNT_DETAILS_SUCCESS:
      return {
        ...state,
        accountDetails: { ...payload },
        isLoading: false
      };
    case actionTypes.GETTING_CLEAR_BANK_ACCOUNT_DETAILS_FAIL:
      return {
        ...state,
        clearBankAccount: { ...state.clearBankAccount, isLoading: false }
      };
    case actionTypes.GETTING_YBL_DOWNTIME_LIST:
      return {
        ...state,
        yblDowntimeList: {
          ...state.yblDowntimeList,
          isLoading: true,
          isError: false,
          error: null
        }
      };
    case actionTypes.GET_YBL_DOWNTIME_LIST_SUCCESS:
      return {
        ...state,
        yblDowntimeList: {
          isLoading: false,
          isError: false,
          error: null,
          data: payload?.data || payload,
          totalPages: payload?.totalPages || 1,
          pageNumber: payload?.pageNumber || 0
        }
      };
    case actionTypes.GET_YBL_DOWNTIME_LIST_FAIL:
      return {
        ...state,
        yblDowntimeList: {
          ...state.yblDowntimeList,
          isLoading: false,
          isError: true,
          error: payload?.message
        }
      };
      case actionTypes.GETTING_FULFILLMENT_BALANCES:
        return {
          ...state,
          fulfillmentBalances: {
            ...state.fulfillmentBalances,
            isLoading: true,
            isError: false,
            error: null
          }
        };
      case actionTypes.GET_FULFILLMENT_BALANCES_SUCCESS:
        return {
          ...state,
          fulfillmentBalances: {
            isLoading: false,
            isError: false,
            error: null,
            data: payload
          }
        };
      case actionTypes.GET_FULFILLMENT_BALANCES_FAIL:
        return {
          ...state,
          fulfillmentBalances: {
            ...state.fulfillmentBalances,
            isLoading: false,
            isError: true,
            error: payload?.message
          }
        };
    case actionTypes.GETTING_ROUTING_CONFIGS:
      return {
        ...state,
        routingConfigs: {
          ...state.routingConfigs,
          isLoading: true,
          isError: false,
          error: null
        }
      };
    case actionTypes.GETTING_META_DATA:
      return {
        ...state,
        metaData: {
          ...state.metaData,
          isLoading: true,
          isError: false,
          error: null
        }
      };
    case actionTypes.GET_ROUTING_CONFIGS_SUCCESS:
      return {
        ...state,
        routingConfigs: {
          isLoading: false,
          isError: false,
          error: null,
          data: payload
        }
      };
    case actionTypes.GET_META_DATA_SUCCESS:
      return {
        ...state,
        metaData: {
          isLoading: false,
          isError: false,
          error: null,
          data: payload
        }
      };
    case actionTypes.GET_ROUTING_CONFIGS_FAIL:
      return {
        ...state,
        routingConfigs: {
          ...state.routingConfigs,
          isLoading: false,
          isError: true,
          error: payload?.message
        }
      };
    case actionTypes.UPDATING_ROUTING_CONFIGS:
      return {
        ...state,
        routingConfigs: {
          ...state.routingConfigs,
          isLoading: true
        }
      };
    case actionTypes.UPDATING_ROUTING_CONFIGS_SUCCESS:
      return {
        ...state,
        routingConfigs: {
          ...state.routingConfigs,
          isLoading: false
        }
      };
    case actionTypes.UPDATING_ROUTING_CONFIGS_FAIL:
      return {
        ...state,
        routingConfigs: {
          ...state.routingConfigs,
          isLoading: false,
          isError: true,
          error: payload?.message
        }
      };
    case actionTypes.GETTING_ROUTING_CONFIG_META:
      return {
        ...state,
        routingConfigMeta: {
          ...state.routingConfigMeta,
          isLoading: true,
          isError: false,
          error: null
        }
      };
    case actionTypes.GET_ROUTING_CONFIG_META_SUCCESS:
      return {
        ...state,
        routingConfigMeta: {
          isLoading: false,
          isError: false,
          error: null,
          data: payload
        }
      };
    case actionTypes.GET_ROUTING_CONFIG_META_FAIL:
      return {
        ...state,
        routingConfigMeta: {
          ...state.routingConfigMeta,
          isLoading: false,
          isError: true,
          error: payload?.message
        }
      };
    case actionTypes.GET_META_DATA_FAIL:
      return {
        ...state,
        metaData: {
          ...state.metaData,
          isLoading: false,
          isError: true,
          error: payload?.message
        }
      };
    default:
      return state;
  }
};

export default rdaDashboardReducer;
